function modal () {
  // Cache del elemento html para evitar múltiples búsquedas
  const html = document.documentElement; // Más eficiente que querySelector('html')
  
  // Función para cerrar modal con requestAnimationFrame para mejor rendimiento
  function closeModal(modal) {
    requestAnimationFrame(() => {
      modal.dataset.show = 'off';
      
      // Si es un modal de video, pausamos y reiniciamos el video
      const modalType = modal.dataset.type;
      if (modalType === 'video') {
        const video = modal.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0; // Reiniciar al inicio
        }
      }
      
      // Usamos setTimeout solo para el html para dar tiempo a la animación
      setTimeout(() => {
        html.dataset.modal = 'off';
      }, 300);
    });
  }

  // Delegación de eventos para abrir modales - un solo listener en lugar de múltiples
  document.addEventListener('click', (e) => {
    // Manejo de apertura de modal
    const btnModal = e.target.closest('.open-modal');
    if (btnModal) {
      e.preventDefault();
      e.stopPropagation();
      
      const modaLink = btnModal.dataset.modal;
      const modal = document.querySelector(`.modal[data-modal="${modaLink}"]`);
      
      if (!modal) return;
      
      const modalType = modal.dataset.type;
      
      // Usamos requestAnimationFrame para cambios visuales
      requestAnimationFrame(() => {
        html.dataset.modal = 'on';
        modal.dataset.show = 'on';
        
        // Reproducir video si es un modal de video
        if (modalType === 'video') {
          const modalVideo = modal.querySelector('video');
          if (modalVideo) {
            // Intentamos reproducir el video con manejo de errores
            const playPromise = modalVideo.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // Ignoramos errores de reproducción (común en dispositivos móviles)
              });
            }
          }
        }
      });
    }
    
    // Manejo de cierre de modal por botón
    const closeBtn = e.target.closest('.modal .close');
    if (closeBtn) {
      e.preventDefault();
      const modal = closeBtn.closest('.modal');
      if (modal) closeModal(modal);
    }
  }, false);
  
  // Función optimizada para manejar clics fuera del contenido
  function handleClickOutside(modal, event) {
    // Determinamos qué elemento considerar como contenido del modal
    let modalContent = modal.querySelector('.modal-box');
    const modalType = modal.dataset.type;
    
    if (!modalContent) {
      // Para modales de video, el video es el contenido principal
      if (modalType === 'video') {
        modalContent = modal.querySelector('video');
      }
      
      // Si aún no hay contenido, usamos el primer elemento hijo
      if (!modalContent && modal.firstElementChild) {
        modalContent = modal.firstElementChild;
      }
      
      // Si no hay contenido, simplemente cerramos
      if (!modalContent) {
        closeModal(modal);
        return;
      }
    }
    
    // Verificamos si el clic fue fuera del contenido
    if (modalContent && !modalContent.contains(event.target) && modal.contains(event.target)) {
      closeModal(modal);
    }
  }
  
  // Un solo listener para todos los modales
  document.addEventListener('click', (e) => {
    const modal = e.target.closest('.modal');
    if (modal && modal.dataset.show === 'on') {
      handleClickOutside(modal, e);
    }
  }, false);
  
  // Detectar dimensiones de videos cuando se cargan
  function detectVideoDimensions() {
    const videos = document.querySelectorAll('video');
    
    if (!videos.length) return;
    
    // Usamos un solo listener para todos los videos
    function handleVideoMetadata(e) {
      const video = e.target;
      const width = video.videoWidth;
      const height = video.videoHeight;
      
      // Aplicamos clases según orientación
      if (width > height) {
        video.classList.add('horizontal');
        video.classList.remove('vertical');
      } else {
        video.classList.add('vertical');
        video.classList.remove('horizontal');
      }
      
      // Disparamos evento personalizado
      video.dispatchEvent(new CustomEvent('videoDimensionsDetected', {
        detail: { width, height, aspectRatio: width / height }
      }));
      
      // Eliminamos el listener una vez procesado
      video.removeEventListener('loadedmetadata', handleVideoMetadata);
    }
    
    // Aplicamos el listener solo donde sea necesario
    videos.forEach(video => {
      if (video.readyState >= 1) { // Ya tiene metadatos
        handleVideoMetadata({ target: video });
      } else {
        video.addEventListener('loadedmetadata', handleVideoMetadata);
      }
    });
  }
  
  // Inicializamos detección de dimensiones
  detectVideoDimensions();
  
  // Observador de mutaciones para detectar nuevos videos
  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      let hasNewVideos = false;
      
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeName === 'VIDEO' || 
                (node.nodeType === 1 && node.querySelector('video'))) {
              hasNewVideos = true;
            }
          });
        }
      });
      
      if (hasNewVideos) {
        detectVideoDimensions();
      }
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
}

export default modal
